// extracted by mini-css-extract-plugin
export default {"toolbar":"project-toolbar_toolbar__Xd9M+"};